import { t } from 'i18next';
import { CommonFlex, CommonText, Container } from 'styledComponents/common';

import no_data from '../../assets/img/no_data.svg';
import {
  DashBoardOverviewColumnCardsContainer,
  DashBoardOverviewColumnContainer,
} from '../../components/DashboardCards/cardStyles';
import PieChart from './pieChart';

const TransactionReportColumn = ({ title, data }) => {
  return (
    <DashBoardOverviewColumnContainer>
      <CommonText fontSize="16px" fontWeight="600">
        {t(title)}
      </CommonText>
      <DashBoardOverviewColumnCardsContainer>
        {data?.length > 0 ? (
          data.map((item, index) => (
            <Container
              key={item.id || index}
              style={{ marginBottom: '15px', padding: '10px' }}
            >
              <CommonFlex justifyContent="space-between">
                <CommonText
                  fontSize="14px"
                  fontWeight="500"
                  margin="0 0 10px 0"
                >
                  {item.officeName}
                </CommonText>
                <CommonText
                  fontSize="14px"
                  fontWeight="500"
                  margin="0 0 10px 0"
                >
                  {t('required_quantity')}: {item.required_quantity}
                </CommonText>
                <CommonText
                  fontSize="14px"
                  fontWeight="500"
                  margin="0 0 10px 0"
                >
                  {item.name}
                </CommonText>
              </CommonFlex>
              <div style={{ margin: '15px 0' }}>
                <PieChart
                  innerChartData={item.innerChartData}
                  outerChartData={item.outerChartData}
                />
              </div>
            </Container>
          ))
        ) : (
          <CommonFlex justifyContent="center">
            <img src={no_data} alt="" width="50%" />
          </CommonFlex>
        )}
      </DashBoardOverviewColumnCardsContainer>
    </DashBoardOverviewColumnContainer>
  );
};

export default TransactionReportColumn;
